<div class="form-group clearfix readonly {{class}}" [ngClass]="{'stacked': labelStacked}">
   <label *ngIf="labelCaption" class="{{labelClass}}" [ngClass]="{'col-form-label': !labelStacked }">
      {{labelCaption}}:
   </label>
   <div class="data-value {{valueClass}}">
      <label class="col-form-label">{{value}}</label>
      <ng-content></ng-content>
   </div>
</div>
